module.exports = __webpack_public_path__ + "img/ro.3617aaa9.svg";